import { authApi } from "./";

/**
 *
 * @returns array of file names
 */
export const getNotification = async () => {
  const response = await authApi.post("notification/get", undefined);
  return response?.data ?? {};
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveNotification = async (msg: string) => {
  const response = await authApi.post("notification/send", { msg });

  return response;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clearNotification = async () => {
  const response = await authApi.post("notification/clear", undefined, {});

  return response;
};
